import { FeatureFlagsState } from '@/@types'

const state: FeatureFlagsState = {
  flags: {
    newDesign: false,
  },
}

export default state
